import { cn, createComponent } from '@lair-finance/util'
import { HTMLAttributes, useState } from 'react'
import { Button } from '@/shared/ui/Button'
import { LocalStorage } from '@/shared/lib/utils/localStorage.ts'
import { Dialog, DialogPortal } from '@/shared/ui/Dialog'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { SERVICE_LINKS } from '@lair-finance/config'

export const CookieAllowBar = () => (
  <CookieAllowModal>
    {({ allow, decline }) => (
      <>
        <p className={'text-white typo-body-2 text-center'}>
          Cookies are used to collect anonymous site visitation data to improve website performance. For more info, read{' '}
          <a className={'text-palette-sky underline'} href={SERVICE_LINKS.PRIVACY} target={'_blank'}>
            Privacy Notice
          </a>
        </p>
        <div className={'inline-flex gap-2'}>
          <Button color={'white'} size={'sm'} className={'min-w-[80px]'} onClick={allow}>
            Allow
          </Button>
          <Button color={'transparent'} size={'sm'} className={'min-w-[80px] border-greyscale-100 text-greyscale-50'} onClick={decline}>
            Decline
          </Button>
        </div>
      </>
    )}
  </CookieAllowModal>
)

const CookieAllowModal = createComponent<
  HTMLDivElement,
  Omit<HTMLAttributes<HTMLDivElement>, 'children'> & { children: ({ allow, decline }: { allow: () => void; decline: () => void }) => React.ReactNode }
>(({ className, children, ...props }, ref) => {
  const [open, setOpen] = useState(!LocalStorage.isAllowed())

  const allow = () => {
    LocalStorage.allowCookie()
    setOpen(false)
  }
  const decline = () => {
    LocalStorage.declineCookie()
    setOpen(false)
  }

  return (
    <Dialog open={open} modal={false}>
      <DialogPortal>
        <DialogPrimitive.Content
          className={cn(
            'fixed bottom-0 left-0 w-full z-50 flex items-center justify-between max-sm:flex-col gap-x-[10px] gap-y-[24px] max-sm:py-5 border border-greyscale-500 bg-greyscale-600 min-h-[56px] sm:min-h-[80px] px-10',
            className,
          )}
          ref={ref}
          {...props}
        >
          {children({ allow, decline })}
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  )
}, 'CookieAllowModal')
